import React, {useState} from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useCreateEmptyEmailListMutation} from "../../../services/emailListApi";
import {toast} from "react-toastify";

const AddNewEmailList = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [createEmptyEmailList, {isLoading: isCreating}] = useCreateEmptyEmailListMutation();

  const [emailListName, setEmailListName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleCreate = async () => {
    setIsLoading(true);
    // async call create , navigate to edit
    try {
      var resourceId = await createEmptyEmailList({title: emailListName.trim()}).unwrap();
      var id = resourceId.id;
      setEmailListName("");
      navigate(`/emailList/${id}/target`);
    } catch (e: any) {
      toast.error("create list failed", e.data?.message || e.message || e.toString());
     }
    setIsLoading(false);
    setOpen(false);
  }

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="contained">
        Add new list
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Upload new email list</DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2}>
            {/* 1) Name */}
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h6">1) Choose name</Typography>
            </Stack>
            <TextField
              required
              label="Target email list"
              placeholder="e.g. Newsletter Subscribers"
              fullWidth
              value={emailListName}
              onChange={(e) => setEmailListName(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{justifyContent: "unset"}}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{width: "100%"}}>
            <Box sx={{flexGrow: 1}}/>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button
              onClick={handleCreate}
              disabled={isLoading || emailListName.trim().length === 0}
              variant="contained"
            >
              Create
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  )
}


export default AddNewEmailList;